import React from 'react';
import { useHistory } from 'react-router-dom';
import * as St from '../../AnticipationConference/styles';
import { cpfCnpjMask, creditCardMask, currencyMask } from '~/utils/masks';
import { IHeaderConference } from '../../model';
import ContainerFlex from '~/components/containerFlex';
import Button from '~/components/button';

const HeaderConference: React.FC<IHeaderConference> = ({
  nomeCompleto,
  cpf,
  numeroCartao,
  valorTotal,
  data,
  financial,
  descontoTotal,
  historyAntecipation,
}) => {
  const history = useHistory<any>();
  console.log('header', data);
  console.log('financial', financial)
  return (
    <St.BoxCard>
      <ContainerFlex row space>
        <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <St.Title>Nome do cliente</St.Title>
          <St.Info>{nomeCompleto}</St.Info>
        </ContainerFlex>
        <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <span>CPF</span>
          <St.Info>{cpfCnpjMask(cpf).masked}</St.Info>
        </ContainerFlex>
        <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <span>Número do cartão</span>
          <St.Info>{creditCardMask(numeroCartao).masked}</St.Info>
        </ContainerFlex>
        {valorTotal && (
          <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <span>Valor total</span>
          <St.Info>{`R$ ${currencyMask(valorTotal)}`}</St.Info>
        </ContainerFlex>
        )}
        {historyAntecipation ? null : (
          <ContainerFlex marginRight={16} gap="15" marginTop={5}>
          <span>Desconto total</span>
          <St.Info>{`R$ ${currencyMask(descontoTotal)}`}</St.Info>
        </ContainerFlex>
        )}

        <ContainerFlex end padding={16}>
          <Button
            fitContent
            onClick={() => {
              console.log(financial)
              if (financial) {
                history.push('/invoice/antecipation-loan', {
                  dataFinancial: data,
                });
              } else {
                history.push('/invoice/antecipation-loan', {
                  dataPurchase: data,
                });
              }
            }}
          >
            <span>Voltar</span>
          </Button>
        </ContainerFlex>
      </ContainerFlex>
    </St.BoxCard>
  );
};

export default HeaderConference;
